// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Force all MUI date picker poppers to be LTR */
.MuiPickersPopper-root,
.MuiPickersPopper-root *,
.MuiPaper-root[role='dialog'],
.MuiDateCalendar-root,
.MuiDateCalendar-root *,
.MuiPickersLayout-root,
.MuiPickersLayout-root *,
.MuiDayCalendar-root,
.MuiDayCalendar-header,
.MuiDayCalendar-weekContainer {
  direction: ltr !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;gCAE8B;EAC9B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,gDAAgD;AAChD;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',\n    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',\n    'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Force all MUI date picker poppers to be LTR */\n.MuiPickersPopper-root,\n.MuiPickersPopper-root *,\n.MuiPaper-root[role='dialog'],\n.MuiDateCalendar-root,\n.MuiDateCalendar-root *,\n.MuiPickersLayout-root,\n.MuiPickersLayout-root *,\n.MuiDayCalendar-root,\n.MuiDayCalendar-header,\n.MuiDayCalendar-weekContainer {\n  direction: ltr !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
